const configMissingExceptionMessage = (propName: string) =>
  `Failed to provide required configured value '${propName}'.`;

const environmentName = process.env.REACT_APP_ENVNAME;
if (!environmentName) throw configMissingExceptionMessage("REACT_APP_ENVNAME");

const applicationVersion = process.env.REACT_APP_VERSION_NO;
if (!applicationVersion) throw configMissingExceptionMessage("REACT_APP_VERSION_NO");

const minimumCalendarDate = process.env.REACT_APP_MINIMUM_CALENDAR_DATE;
if (!minimumCalendarDate) throw configMissingExceptionMessage("REACT_APP_MINIMUM_CALENDAR_DATE");

const msalTenantId = process.env.REACT_APP_MSAL_TENANT_ID;
if (!msalTenantId) throw configMissingExceptionMessage("REACT_APP_MSAL_TENANT_ID");

const msalAppId = process.env.REACT_APP_MSAL_APP_ID;
if (!msalAppId) throw configMissingExceptionMessage("REACT_APP_MSAL_APP_ID");

const msalAuthenticationScope = process.env.REACT_APP_MSAL_AUTHENTICATION_SCOPE;
if (!msalAuthenticationScope) throw configMissingExceptionMessage("REACT_APP_MSAL_AUTHENTICATION_SCOPE");

const cbpBaseUrl = process.env.REACT_APP_CBP_URL;
if (!cbpBaseUrl) throw configMissingExceptionMessage("REACT_APP_CBP_URL");

const cbpAspireUrl = process.env.REACT_APP_CBP_ASPIRE_URL;
if (!cbpAspireUrl) throw configMissingExceptionMessage("REACT_APP_CBP_ASPIRE_URL");

const EnvironmentConfiguration = {
  applicationVersion,
  environmentName,
  legacyBaseApiUrl: cbpBaseUrl,
  aspireBaseApiUrl: cbpAspireUrl,
  minimumCalendarDate,
  msal: {
    applicationId: msalAppId,
    authenticationScope: msalAuthenticationScope,
    tenantId: msalTenantId
  }
};

export default EnvironmentConfiguration;
